import { createDrawerStore } from '../drawer/createDrawerStore';

export const useSavedLocationDrawerStore = createDrawerStore();
